export const SET_UPDATE_PROFILE_FORM_DATA = 'SET_UPDATE_PROFILE_FORM_DATA';
export const LOAD_SELECTED_PROFILE_BEGIN = 'LOAD_SELECTED_PROFILE_BEGIN';
export const LOAD_SELECTED_PROFILE_ERROR = 'LOAD_SELECTED_PROFILE_ERROR';
export const LOAD_SELECTED_PROFILE_SUCCESS = 'LOAD_SELECTED_PROFILE_SUCCESS';
